import { createContext, useContext, useEffect, useState } from "react";
import { getEquipmentMetadata, getWorkoutMetadata } from "api/exercisePlan";

export const MetaContext = createContext();

export const useMeta = () => useContext(MetaContext);

export const MetaProvider = ({ children }) => {
  const [dynamicOptions, setDynamicOptions] = useState({
    workoutsCategories: [],
    difficultiesLevel: [],
    equipmentCategories: [],
  });
  const fetchDynamicOptions = async () => {
    try {
      const [workoutMeta, equipmentMeta] = await Promise.all([
        getWorkoutMetadata(),
        getEquipmentMetadata(),
      ]);

      const newDynamicOptions = {
        workoutsCategories: workoutMeta.categories,
        difficultiesLevel: workoutMeta.difficulties,
        equipmentCategories: equipmentMeta.categories,
      };

      setDynamicOptions(newDynamicOptions);

      return newDynamicOptions;
    } catch (error) {
      console.error("Error fetching dynamic options:", error);
    //   toast.error("Failed to load exercise options.");
      return dynamicOptions;
    }
  };

  useEffect(() => {
    fetchDynamicOptions();
  }, []);
  return (
    <MetaContext.Provider value={{ dynamicOptions, setDynamicOptions }}>
      {children}
    </MetaContext.Provider>
  );
};
